import Experience from './Experience.js'
import * as THREE from 'three'

export default class ColorControls {
    constructor(blackHole) {
        this.experience = new Experience()
        this.blackHole = blackHole

        // 默认颜色
        this.defaultColors = {
            inner: '#FFD700', // 金色
            outer: '#FF8C00', // 橙色
            glare: '#FFFACD'  // 淡金白
        }

        this.setDOM()
        this.setEvents()
    }

    setDOM() {
        // 获取DOM元素
        this.innerColorPicker = document.getElementById('innerColorPicker')
        this.outerColorPicker = document.getElementById('outerColorPicker')
        this.glarePicker = document.getElementById('glarePicker')
        this.resetButton = document.getElementById('resetColors')
    }

    setEvents() {
        // 内部颜色变化
        this.innerColorPicker.addEventListener('input', () => {
            const color = new THREE.Color(this.innerColorPicker.value)
            this.blackHole.commonUniforms.uInnerColor.value = color
        })

        // 外部颜色变化
        this.outerColorPicker.addEventListener('input', () => {
            const color = new THREE.Color(this.outerColorPicker.value)
            this.blackHole.commonUniforms.uOuterColor.value = color
        })

        // 光晕颜色变化
        this.glarePicker.addEventListener('input', () => {
            const color = new THREE.Color(this.glarePicker.value)
            this.blackHole.particles.material.uniforms.uInnerColor.value = color
        })

        // 重置颜色
        this.resetButton.addEventListener('click', () => {
            this.resetColors()
        })
    }

    resetColors() {
        // 重置颜色选择器
        this.innerColorPicker.value = this.defaultColors.inner
        this.outerColorPicker.value = this.defaultColors.outer
        this.glarePicker.value = this.defaultColors.glare

        // 重置黑洞颜色
        this.blackHole.commonUniforms.uInnerColor.value = new THREE.Color(this.defaultColors.inner)
        this.blackHole.commonUniforms.uOuterColor.value = new THREE.Color(this.defaultColors.outer)
        this.blackHole.particles.material.uniforms.uInnerColor.value = new THREE.Color(this.defaultColors.glare)
    }
}